export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13685.3036ed6c.jpg";